import React from 'react'

function Comprehensive({ height, width }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 74 74">
      <defs>
        <linearGradient x1="0.014" x2="1" y1="0.5" y2="0.5" gradientUnits="objectBoundingBox">
          <stop offset="0" stopColor="#60c9b1" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <filter width="74" height="74" x="0" y="0" filterUnits="userSpaceOnUse">
          <feOffset dy="3" />
          <feGaussianBlur result="blur" stdDeviation="3" />
          <feFlood floodOpacity="0.161" />
          <feComposite in2="blur" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g transform="translate(-173 -4520)">
        <g data-name="Safe and secure transactions" transform="translate(186 4531)">
          <path fill="none" d="M0 0h48v47H0z" data-name="Path 6" />
          <g data-name="Safe and secure transactions">
            <path fill="none" d="M0 0h48v47H0z" data-name="Path 6" />
            <text fill="#2f6fb1" data-name="" fontFamily="JioMoney" fontSize="48" transform="translate(2 46)">
              <tspan x="0" y="0">
                
              </tspan>
            </text>
            <text fill="#fff" data-name="" fontFamily="JioMoney" fontSize="48" transform="translate(0 44)">
              <tspan x="0" y="0">
                
              </tspan>
            </text>
          </g>
        </g>
      </g>
    </svg>
  )
}

export default Comprehensive
